import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { DateInputComponent } from '../components/FormComponents/DateInputComponent';
import { EmailConfirmButtonComponent } from '../components/FormComponents/EmailConfirmButtonComponent';
import { TextInputComponent } from '../components/FormComponents/TextInputComponent';
import { RadioInputComponent } from '../components/FormComponents/RadioInputComponent';
import { StatementCategoryModel, StatementCategoryOperationEnum } from '../models';
import { StatementTypeEnum } from '../models/StatementTypeEnum';
import { useStores } from '../stores/Hooks';
import { DeleteFormCallbackEnum, ModalTypeEnum } from '../stores/libraries/ModalLibrary';
import { RegisterRightBlock } from './RightBlock/RegisterRightBlock';

export const RegisterPage: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();
		const store = uiState.register;

		function changeOperation(el: StatementCategoryModel, newOperation: string): void
		{
			if (newOperation === "None" && uiState.files.IsNeedDeleteFileTypes(el.Id))
			{
				uiState.modal.SetChangeFormAction(DeleteFormCallbackEnum.DeletingCategory);
				uiState.modal.SetDeletingCategory(el);
				uiState.modal.setShowModal(true, ModalTypeEnum.DeleteFormRequired, "Данные по услугам оператора ЭДО изменились", "Вы уверены, что хотите удалить эту услугу?<br />Все загруженные файлы в рамках этой услуги будут удалены.");
				return;
			}
			else
			{
				store.setSelectedServiceCategories(el, newOperation);
				uiState.files.UpdateFileTypes();
			}
		}

		return (
			<div className="row no-gutters scrolled-container">
				<div className="col-lg">
					<div className="main-steps-form">
						<div className="info-on-mobile d-lg-none">
							<button
								className="text-primary text-center link d-flex align-items-center f-14"
								type="button"
								onClick={() => uiState.modal.ShowComponent("Информация по разделу", RegisterRightBlock)}
							>Информация по разделу <img src="./i/icons/question.svg" className="ml-2" alt="Информация по разделу" /></button>
						</div>
						<div className="form-block-container">

							<div className="form-block">
								<div className="form-block-header">Тип заявления&nbsp;<span className="text-danger">*</span></div>
								<RadioInputComponent
									IsDisabled={uiState.IsDisabled}
									Label="Первичная подача"
									Name="StatementType"
									OnChange={(value) => { if (value) { store.setStatementType(StatementTypeEnum.NewInformation) } }}
									Value={store.StatementType === StatementTypeEnum.NewInformation}
								/>
								<RadioInputComponent
									IsDisabled={uiState.IsDisabled}
									Label="Уточнение"
									Name="StatementType"
									OnChange={(value) => { if (value) { store.setStatementType(StatementTypeEnum.ClarifyInformation) } }}
									Value={store.StatementType === StatementTypeEnum.ClarifyInformation}
								/>
								<RadioInputComponent
									IsDisabled={uiState.IsDisabled}
									Label="Исключение из реестра"
									Name="StatementType"
									OnChange={(value) => { if (value) { store.setStatementType(StatementTypeEnum.RemoveInformation) } }}
									Value={store.StatementType === StatementTypeEnum.RemoveInformation}
								/>
							</div>

							<div className="form-block">
								<div className="form-block-header">Категория услуг оператора ЭДО&nbsp;<span className="text-danger">*</span></div>
								{
									Array.from(dataState.Categories.values()).map
										((el, ind) =>
											<div key={el.Id.replace(/-/gi, "")} className={"formCheck" + (ind === 0 ?" mb-6":"")}>
												<label className={"input-btns checkbox-btn" + (store.ServiceCategoriesError.length > 0 ? " invalid" : "")}>
													<input
														type="checkbox"
														disabled={uiState.IsDisabled}
														onChange={(event) => changeOperation(el, (event.target as HTMLInputElement).checked ? (store.StatementType === StatementTypeEnum.RemoveInformation ? StatementCategoryOperationEnum.RemoveInformation : StatementCategoryOperationEnum.NewInformation) : StatementCategoryOperationEnum.None)}
														checked=
														{
															store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.NewInformation
															|| store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.ClarifyInformation
															|| store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.RemoveInformation
														}
													/>
													<span className="input-indicator"></span>
													<span>
														{el.Name} (&nbsp;<a href={el.LinkNK.Href} target="_blank" rel="noopener noreferrer nofollow">{el.LinkNK.Name}</a>&nbsp;)
														<span className="mb-0 error-message text-danger" style={{ marginLeft: "-37px", marginTop: "7px" }}>{ind === 1 ? store.ServiceCategoriesError : ""}</span>
													</span>
												</label>
												{(
													store.StatementType === StatementTypeEnum.ClarifyInformation
													&& store.SelectedServiceCategories.get(el.Id)?.Operation
													&& store.SelectedServiceCategories.get(el.Id)?.Operation !== StatementCategoryOperationEnum.None
												) &&
													<>
														<div className="radio-inside">
															<RadioInputComponent
																IsDisabled={uiState.IsDisabled}
																Label="Включить в реестр ОЭД"
																Name={el.Id.replace(/-/gi, "")}
															OnChange={(value) => { if (value) { changeOperation(el, StatementCategoryOperationEnum.NewInformation) } }}
															Value={store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.NewInformation || store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.RemoveInformation}
															/>
															<RadioInputComponent
																IsDisabled={uiState.IsDisabled}
																Label="Изменить сведения реестровой записи"
																Name={el.Id.replace(/-/gi, "")}
																OnChange={(value) => { if (value) { changeOperation(el, StatementCategoryOperationEnum.ClarifyInformation) } }}
																Value={store.SelectedServiceCategories.get(el.Id)?.Operation === StatementCategoryOperationEnum.ClarifyInformation}
															/>
														</div>
													</>
												}
											</div>
										)
								}
							</div>

							{store.StatementType === StatementTypeEnum.ClarifyInformation &&
								<div className="form-block">
									<div className="row">
										<div className="col-xl-6 mb-2 mb-md-3 mb-lg-4 mb-xl-0">
											<TextInputComponent
												IsRequired={true}
												Error="Введен некорректный номер обращения"
												IsDisabled={store.OldRegisterNumber.IsDisabled}
												IsValid={store.OldRegisterNumber.IsValid}
												Label="Идентификационный номер обращения"
												MaxLength={10}
												Placeholder="Введите номер из письма о регистрации"
												Value={store.OldRegisterNumber.Value ?? ""}
												OnChange={(value: string) => store.OldRegisterNumber.setValue(value)}
												OnValidate={() => store.OldRegisterNumber.Validate()}
											/>
										</div>
										<div className="col-xl-6 mb-0">
											<DateInputComponent
												IsRequired={true}
												Error="Введена некорректная дата обращения"
												IsDisabled={store.OldRegisterDate.IsDisabled}
												IsValid={store.OldRegisterDate.IsValid}
												Label="Дата регистрации обращения"
												Value={store.OldRegisterDate.Value}
												OnChange={(value: Date | null) => store.OldRegisterDate.setValue(value)}
												OnValidate={() => store.OldRegisterDate.Validate()}
											/>
										</div>
									</div>
								</div>
							}

							<div className="form-block">
								<EmailConfirmButtonComponent
									IsRequired={true}
									Error="Введите правильный адрес электронной почты"
									IsDisabled={store.FeedbackEmail.IsDisabled}
									IsValid={store.FeedbackEmail.IsValid}
									Label="Адрес электронной почты для обратной связи"
									Placeholder="Введите адрес электронной почты"
									Value={store.FeedbackEmail.Value ?? ""}
									IsConfirmed={store.FeedbackEmail.IsConfirmed}
									ConfirmedValue={store.FeedbackEmail.ConfirmedValue ?? ""}
									OnChange={(value: string) => store.FeedbackEmail.setValue(value)}
									OnValidate={() => store.FeedbackEmail.Validate()}
									OnClick={() => { if (store.Validate()) uiState.SendCheckMail(); }}
								/>
							</div>

							{(store.StatementType === StatementTypeEnum.ClarifyInformation || store.StatementType === StatementTypeEnum.RemoveInformation) &&
								<div className="form-block">
									<div className="input-text-block">
										<label>
											<span className="label-title">Комментарии</span>
											<textarea
												className="form-text"
												value={store.Comment}
												disabled={uiState.IsDisabled}
												maxLength={255}
												onChange={(event: React.SyntheticEvent) => store.setComment((event.target as HTMLInputElement).value)}
												rows={5}></textarea>
										</label>
									</div>
								</div>
							}
						</div>
					</div>
				</div>
				<div className="col-lg-auto sidebar d-none d-lg-block">
					<RegisterRightBlock />
				</div>
			</div>
		);
	}
)
